// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ggxv","type":"styles_type__2J4Zk","choices":"styles_choices__2Ob8_"};